import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, skip, pairwise, skipUntil,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

export const stateRefreshStream = () => {
  const nulledRaw$ = Dispatch.getState('RawStates')
    .pipe(
      filter(e => e === null),
      take(1),
      map(e => true)
    )
  const nulledRaw2$ = Dispatch.getState('RawStates')
    .pipe(
      skipUntil(nulledRaw$),
      filter(e => e !== null),
      take(1),
      map(e => false)
    )
  return Rx.merge(nulledRaw$, nulledRaw2$)
}